import { useState, useEffect } from 'react'
import './Loader.css'

// ============================================
// VARIABLES GLOBALES POUR GESTION UNIQUE
// ============================================
let hasLoadedOnce = false
let loaderStartTime = 0

function Loader() {
  // ✅ État initial : visible uniquement si premier chargement
  const [show, setShow] = useState(() => {
    if (hasLoadedOnce) {
      console.log('⏭️ Loader déjà affiché - Bloqué')
      return false
    }
    
    console.log('✅ Premier affichage du Loader')
    loaderStartTime = Date.now()
    return true
  })

  const [fadeOut, setFadeOut] = useState(false)

  useEffect(() => {
    if (!show) return

    console.log('🎬 Loader: Démarrage')
    
    // ✅ Timer minimum de 3 secondes (réduit de 5 pour être plus rapide)
    const minDisplayTime = 3000
    
    // ✅ Attendre que le document soit chargé
    const handleLoad = () => {
      const elapsedTime = Date.now() - loaderStartTime
      const remainingTime = Math.max(0, minDisplayTime - elapsedTime)
      
      console.log(`⏰ Page chargée après ${elapsedTime}ms`)
      console.log(`⏳ Attente de ${remainingTime}ms supplémentaires`)
      
      setTimeout(() => {
        console.log('🎭 Début de l\'animation de fermeture')
        setFadeOut(true)
        
        // ✅ Retirer complètement après l'animation (500ms)
        setTimeout(() => {
          console.log('✅ Loader fermé définitivement')
          setShow(false)
          hasLoadedOnce = true
        }, 500)
      }, remainingTime)
    }

    // ✅ Si le document est déjà chargé
    if (document.readyState === 'complete') {
      handleLoad()
    } else {
      window.addEventListener('load', handleLoad)
      
      // ✅ Sécurité : Forcer la fermeture après 5 secondes max
      const maxTimer = setTimeout(() => {
        console.log('⚠️ Timeout sécurité - Fermeture forcée')
        handleLoad()
      }, 5000)
      
      return () => {
        window.removeEventListener('load', handleLoad)
        clearTimeout(maxTimer)
      }
    }
  }, [show])

  // ✅ Ne rien afficher si show est false
  if (!show) {
    return null
  }

  return (
    <div className={`loader-container ${fadeOut ? 'fade-out' : ''}`}>
      {/* Background avec scene.jpg */}
      <div className="loader-background"></div>
      
      {/* Overlay gradient */}
      <div className="loader-overlay"></div>
      
      {/* Contenu principal */}
      <div className="loader-content">
        {/* Logo avec glow */}
        <div className="loader-logo-wrapper">
          <div className="loader-logo-glow"></div>
          <div className="loader-logo"></div>
        </div>
        
        {/* Texte "Radio 100% Johnny" */}
        <div className="loader-text">
          <h1 className="loader-title">
            <span className="loader-title-radio">Radio</span>
            <span className="loader-title-100">100%</span>
            <span className="loader-title-johnny">Johnny</span>
          </h1>
          <p className="loader-subtitle">24h/24 - 7j/7</p>
        </div>
        
        {/* Disque vinyle + Barre de progression */}
        <div className="loader-progress-container">
          {/* Disque vinyle tournant */}
          <div className="loader-vinyl">
            <div className="loader-vinyl-inner">
              <div className="loader-vinyl-label"></div>
            </div>
          </div>
          
          {/* Barre de progression */}
          <div className="loader-progress-bar">
            <div className="loader-progress-fill"></div>
          </div>
          
          {/* Texte "Chargement..." */}
          <p className="loader-loading-text">Chargement...</p>
        </div>
      </div>
      
      {/* Notes de musique flottantes */}
      <div className="loader-notes">
        <span className="loader-note">♪</span>
        <span className="loader-note">♫</span>
        <span className="loader-note">♪</span>
        <span className="loader-note">♫</span>
      </div>
    </div>
  )
}

export default Loader